import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette }) => ({
    box: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#b2b9e1",
        fontSize: 14,
        fontWeight: 500,
        borderRadius: 12,
        minWidth: 24,
        height: 24,
        borderColor: "#b2b9e1",
        borderWidth: 1,
        borderStyle: "solid",
    },
    box_active: {
        background: palette.primary.main,
        borderColor: palette.primary.main,
        color: "#ffffff",
    },
    box_completed: {
        background: palette.primary.main,
        borderColor: palette.primary.main,
        color: "#ffffff",
    },
    box_error: {
        borderColor: palette.secondary.main,
        background: palette.secondary.main,
        color: "#ffffff",
    },
}));
//# sourceMappingURL=ui_step_icon.css.js.map